import { render, staticRenderFns } from "./ModelPart.vue?vue&type=template&id=60e8289b&scoped=true&"
import script from "./ModelPart.vue?vue&type=script&lang=js&"
export * from "./ModelPart.vue?vue&type=script&lang=js&"
import style0 from "./ModelPart.vue?vue&type=style&index=0&id=60e8289b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e8289b",
  null
  
)

export default component.exports